<template>
  <div
    v-if="tableCfg.paging.showPaging"
    :class="{ paging: true, small: tableCfg.size && tableCfg.size === 'small' }"
  >
    <a-pagination
      style="display: inline;"
      :size="tableCfg.size"
      :current="tableCfg.paging.pageNo"
      :page-size="tableCfg.paging.pageSize"
      :show-size-changer="tableCfg.paging.showSizeChanger === undefined ? true : tableCfg.paging.showSizeChanger"
      :show-total="() => `共 ${ pageCount } 页 / ${ tableCfg.paging.total } 条记录`"
      :page-size-options="pageSizeList"
      :total="tableCfg.paging.total"
      @showSizeChange="onSizeChange"
      @change="onCurrentChange"
    >
    <!-- :show-quick-jumper="tableCfg.paging.showQuickJumper === undefined ? true : tableCfg.paging.showQuickJumper" -->
      <!-- <template
        slot="buildOptionText"
        slot-scope="props"
      >
        <span>
          {{ props.value }}条/页-{{ props }}
        </span>
      </template> -->
    </a-pagination>

    <span v-if="jumpPageVisable">
      跳至
      <a-input
        v-model="jumpPage"
        addon-after="页"
        style="display:inline-block;width:100px;margin-right:10px"
        @pressEnter="onJumpPage"
      />
    </span>

    <a-input
      v-if="autoPageSize"
      v-model="autoSize"
      addon-after="条/页"
      style="display:inline-block;width:120px"
      @pressEnter="onAutoSize"
    />

    <ul
      unselectable="unselectable"
      class="ant-pagination"
      style="display: inline;"
    >
      <li
        title="刷新表格"
        class="ant-pagination-next"
      >
        <a-button
          v-if="jumpPageVisable"
          class="reload"
          @click="onRefresh"
        >
          <a-icon type="reload" />
        </a-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PaginationxCheck',
  props: {
    tableCfg: {
      type: Object,
      required: true
    },
    autoPageSize: {
      type: Boolean,
      default: false
    },
    // 是否显示"跳至"按钮
    jumpPageVisable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentPageSize: 10,
      pageSizeList: [],
      autoSize: null, // 自定义pagesize
      jumpPage: null,
      jumpPageNo: null
    }
  },
  computed: {
    pageCount () {
      return Math.floor((this.tableCfg.paging.total + this.tableCfg.paging.pageSize - 1) / this.tableCfg.paging.pageSize)
    }
  },
  watch: {
    jumpPage (val) {
      if (val && parseInt(val, 10) > 0 && parseInt(val, 10) < this.pageCount) {
        this.jumpPageNo = parseInt(val, 10)
      } else if (parseInt(val, 10) < 1) {
        this.jumpPageNo = 1
      } else {
        this.jumpPageNo = this.pageCount
      }
    }
    // autoSize (val) {
    //   if (reg.test(val)) {
    //     val = val.replace(/^\+?[1-9]\d*$/, '')
    //   }
    // }
  },
  created () {
    this.pageSizeList = this.tableCfg.paging.pageSizeOptions
  },
  methods: {
    onCurrentChange (pageNo) {
      this.$antdx.tablexCheck.jump(this.tableCfg, pageNo).then(() => {
        this.jumpPage = null
      })
    },
    onSizeChange (pageNo, pageSize) {
      this.currentPageSize = pageSize
      this.autoSize = pageSize
      this.$antdx.tablexCheck.resize(this.tableCfg, pageSize).then(() => {
        this.jumpPage = null
      })
    },
    onAutoSize () {
      const size = this.autoSize && parseInt(this.autoSize, 10) > 0 ? this.autoSize : this.currentPageSize
      this.$antdx.tablexCheck.resize(this.tableCfg, parseInt(size, 10)).then(() => {
        this.jumpPage = null
      })
    },
    onJumpPage () {
      this.$antdx.tablexCheck.jump(this.tableCfg, this.jumpPageNo).then(() => {
        this.jumpPage = null
      })
    },
    onRefresh () {
      if (this.autoPageSize) {
        if (this.jumpPage) {
          this.tableCfg.paging.pageSize = this.autoSize && parseInt(this.autoSize, 10) > 0 ? parseInt(this.autoSize, 10) : parseInt(this.currentPageSize, 10)
          const currentPageCountLimit = Math.floor((this.tableCfg.paging.total + this.tableCfg.paging.pageSize - 1) / this.tableCfg.paging.pageSize)
          this.tableCfg.paging.pageNo = this.jumpPage > currentPageCountLimit ? parseInt(currentPageCountLimit, 10) : parseInt(this.jumpPage, 10)
          this.$antdx.tablexCheck.refresh(this.tableCfg).then(() => {
            this.jumpPage = null
          })
        } else {
          this.onAutoSize()
        }
      } else {
        /* eslint-disable */
        if (this.jumpPage) {
          this.onJumpPage()
        } else {
          this.$antdx.tablexCheck.refresh(this.tableCfg)
        }
      }
    }
  }
}
</script>

<style scoped>
  .paging {
    text-align: center;
    line-height: 30px;
    margin-top: 15px;
  }

  .paging.small {
    margin-top: 10px;
  }

  .paging >>> .ant-select {
    width: unset;
  }

  .paging .reload {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    padding: 0px;
    font-size: 12px;
    margin-left: 4px;
  }

  .paging.small .reload {
    min-width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 11px;
    margin-left: 0px;
  }

  .paging >>> ul.ant-pagination:first-child::after {
    display: inline;
  }
</style>
